<div class="flex items-start gap-lg pb-lg">
    <ng-icon
        *ngIf="viewModel()?.showBackButton"
        hlm
        name="lucideChevronLeft"
        size="lg"
        (click)="onGoBack()"
        class="cursor-pointer"
    ></ng-icon>
    <div class="flex flex-col items-start">
        <div class="text-xl">{{ viewModel()?.title }}</div>
        <div *ngIf="viewModel()?.subtitle" class="text-2xl font-bold">{{ viewModel()?.subtitle }}</div>
    </div>
</div>
<div
    variant="default"
    class="bg-primary-light flex justify-between rounded-sm items-center mb-lg pb-md pt-md pl-lg pr-lg"
    *ngIf="showAccountContainer()"
>
    <div *ngIf="!userLoggedIn" class="text-sm font-semibold">Booked with us before?</div>
    <button *ngIf="!userLoggedIn" id="logIn" (click)="onClickLogIn()" hlmBtn>Log In</button>
    <div *ngIf="userLoggedIn" class="text-sm">
        <span class="text-sm font-semibold">Welcome Back!</span><br /><span class="text-xs"
            >Browse services or head to your profile to manage appointments.</span
        >
    </div>
    <button *ngIf="userLoggedIn" id="myProfile" (click)="onClickAccount()" hlmBtn>My Profile</button>
</div>
<hlm-sheet #sheet side="bottom">
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="login-sheet">
        <hlm-sheet-header class="pl-0">
            <h1 hlmSheetTitle>Log In</h1>
        </hlm-sheet-header>
        <div>
            <app-login-form (closeContainer)="onCloseSheet()"></app-login-form>
        </div>
    </hlm-sheet-content>
</hlm-sheet>
